import React from 'react';
import { 
    Create, 
    SimpleForm, 
    ReferenceInput,
    SelectInput,
    AutocompleteInput,
    DateInput,
    TextInput,
    required
} from 'react-admin';
import { FormToolbar } from "../../common/FormToolbar";

export const StudentEnrollmentCreate = props => {
    return (
        <React.Fragment>
            <Create label="Create Enrollment" {...props}>
                <SimpleForm toolbar={<FormToolbar {...props} />} className="main-form">
                    <ReferenceInput 
                        source="student_id" 
                        reference="student"
                        label="Student"
                        className="first_inline_input"
                        filterToQuery={searchText => ({ 'first_name': searchText })}
                    >
                        <AutocompleteInput 
                            optionText={(record) => `${record.first_name}${record.middle_name ? ' ' + record.middle_name : ''} ${record.last_name}`}
                            shouldRenderSuggestions={(val) => { return val && val.trim().length >= 2 }}
                            validate={[required()]} 
                        />
                    </ReferenceInput>
                    
                    <ReferenceInput 
                        source="branch_id" 
                        reference="branch"
                        label="Branch"
                        className="last_inline_input"
                    >
                        <SelectInput optionText="branch_name" validate={[required()]} fullWidth={true} />
                    </ReferenceInput>
                    
                    <ReferenceInput 
                        source="program_id" 
                        reference="program"
                        label="Program"
                        className="first_inline_input"
                    >
                        <SelectInput optionText="program_name" validate={[required()]} fullWidth={true} />
                    </ReferenceInput>
                    
                    <ReferenceInput 
                        source="class_id" 
                        reference="genere"
                        label="Class"
                        className="last_inline_input"
                    >
                        <SelectInput optionText="class_name" validate={[required()]} fullWidth={true} />
                    </ReferenceInput>
                    
                    <ReferenceInput 
                        source="section_id" 
                        reference="section"
                        label="Section (Optional)"
                        className="first_inline_input"
                    >
                        <SelectInput optionText="section" fullWidth={true} />
                    </ReferenceInput>
                    
                    <SelectInput 
                        source="board" 
                        label="Board" 
                        choices={[
                            { id: 'RBSE', name: 'RBSE' },
                            { id: 'CBSE', name: 'CBSE' },
                            { id: 'IGCSE', name: 'IGCSE' },
                        ]} 
                        validate={[required()]}
                        defaultValue="RBSE"
                        fullWidth={true}
                        className="last_inline_input"
                    />
                    
                    <DateInput 
                        source="enrollment_date" 
                        label="Enrollment Date"
                        fullWidth={true}
                        className="first_inline_input"
                        validate={[required()]}
                        defaultValue={new Date().toISOString().split('T')[0]}
                    />
                    
                    <TextInput 
                        source="academic_year" 
                        label="Academic Year"
                        fullWidth={true}
                        className="last_inline_input"
                        validate={[required()]}
                        helperText="Format: 2025-26"
                    />
                    
                    <SelectInput 
                        source="status" 
                        label="Status" 
                        choices={[
                            { id: 'active', name: 'Active' },
                            { id: 'inactive', name: 'Inactive' },
                            { id: 'completed', name: 'Completed' },
                            { id: 'transferred', name: 'Transferred' },
                            { id: 'withdrawn', name: 'Withdrawn' },
                        ]} 
                        defaultValue="active"
                        fullWidth={true}
                    />
                </SimpleForm>
            </Create>
        </React.Fragment>
    );
}
